import { generateQueryKey } from 'query';

export const getLeaderboardQueryKey = (pageSize: number) => generateQueryKey(['accounts', 'leaderboard', pageSize]);
export const getOverallPointsQueryKey = (id: string) => generateQueryKey(['accounts', 'user', id]);
export const getUsersQueryKey = (userId: string) => generateQueryKey(['users', userId]);
